/* eslint-disable no-use-before-define */
import React from 'react'
import TextField from '@material-ui/core/TextField'
import Autocomplete, {
  createFilterOptions,
} from '@material-ui/lab/Autocomplete'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import { Checkbox } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import { debounce } from 'throttle-debounce'

import { setSiteNameFilterControlPanel } from '../../../../store/actions/controlPanel'

const MultiSelect = ({
  items,
  selectedValues,
  label,
  placeholder,
  selectAllLabel,
  onToggleOption,
  onClearOptions,
  onSelectAll,
  getOptionLabel,
}) => {
  const dispatch = useDispatch()
  const sitesByAssetsFlag = useSelector(
    (state) => state.controlPanel.sitesByAssetsFlag
  )

  const allSelected = items.length === selectedValues.length
  const handleToggleSelectAll = () => {
    onSelectAll && onSelectAll(!allSelected)
  }

  const handleChange = (event, selectedOptions, reason) => {
    if (reason === 'select-option' || reason === 'remove-option') {
      if (!sitesByAssetsFlag) {
        if (selectedOptions.find((option) => option.name === 'select-all')) {
          handleToggleSelectAll()
        } else {
          onToggleOption && onToggleOption(selectedOptions)
        }
      }
    } else if (reason === 'clear') {
      onClearOptions && onClearOptions()
    }
  }

  const handleBlur = (e) => {
    dispatch(setSiteNameFilterControlPanel(''))
  }

  const optionRenderer = (option, { selected }) => {
    const selectAllProps =
      option.name === 'select-all' // To control the state of 'select-all' checkbox
        ? { checked: allSelected }
        : {}
    return (
      <>
        <Checkbox
          color="primary"
          icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
          checkedIcon={<CheckBoxIcon fontSize="small" />}
          style={{ marginRight: 8 }}
          checked={selected}
          {...selectAllProps}
        />
        {getOptionLabel(option)}
      </>
    )
  }

  const handleSiteName = (siteName) => {
    dispatch(setSiteNameFilterControlPanel(siteName))
  }
  const handleSiteNameDebounced = debounce('400', handleSiteName)

  const inputRenderer = (params) => (
    <TextField
      {...params}
      label={label}
      placeholder={placeholder}
      onChange={(e) => handleSiteNameDebounced(e.target.value)}
      inputProps={{ ...params.inputProps, readOnly: sitesByAssetsFlag }}
    />
  )

  const getOptionSelected = (option, anotherOption) =>
    option.name === anotherOption.name

  const filter = createFilterOptions()

  const filterOptions = (options, params) => {
    params.inputValue = params.inputValue.trim()
    const filtered = filter(options, params)
    return filtered.length > 0
      ? [{ id: selectAllLabel, name: 'select-all' }, ...filtered]
      : [...filtered]
  }

  return (
    <Autocomplete
      multiple
      size="small"
      limitTags={2}
      options={items}
      value={selectedValues}
      disableCloseOnSelect
      getOptionLabel={getOptionLabel}
      getOptionSelected={getOptionSelected}
      filterOptions={filterOptions}
      onChange={handleChange}
      onBlur={handleBlur}
      renderOption={optionRenderer}
      renderInput={inputRenderer}
    />
  )
}

MultiSelect.defaultProps = {
  limitTags: 5,
  items: [],
  selectedValues: [],
  getOptionLabel: (value) => value,
}

export default MultiSelect
